export default {
  "content": "<g clip-path=\"url(#a)\"><path fill=\"#3F4450\" d=\"M15.309 12.693h-.03c-.657-.483-1.729-3.723-2.429-7.888a9.555 9.555 0 00-.273-.993A5.133 5.133 0 007.8.53a5.058 5.058 0 00-4.819 3.4c-.093.255-.17.515-.231.779-.7 4.133-1.371 7.477-2.021 7.985H.691a.656.656 0 100 1.306h5.252c.02.058.049.111.074.166a1.989 1.989 0 003.966 0c.025-.055.054-.108.074-.166h5.252a.654.654 0 100-1.307z\"/></g><defs><clipPath id=\"a\"><path fill=\"#fff\" d=\"M0 0h16v16H0z\"/></clipPath></defs>",
  "attrs": {
    "xmlns": "http://www.w3.org/2000/svg",
    "width": "16",
    "height": "16",
    "fill": "none"
  }
};